module.exports = __webpack_public_path__ + "img/SocialIcon.589a2152.svg";